import { Fragment } from 'react'

import { Translation } from 'cng-common/features/translations'

import { AttentionCount } from '../components/attentionCount'
import type { TAttentionStatusesMetaPart } from '../types'

interface IAttentionStatusesMetaProps {
  parts: TAttentionStatusesMetaPart[]
}

/**
 * A row's second line. The parts arrive apart rather than joined because the line mixes a phrase
 * of ours — `12 partners` — with names the payload owns, and only ours is drawn through
 * `<Translation />`; the separator between them belongs to the layout, not to the dictionary.
 */
export const AttentionStatusesMeta = ({ parts }: IAttentionStatusesMetaProps) => (
  <>
    {/* The line is rebuilt whole on every render and never reordered, so its own place in it
        is the part's identity. */}
    {parts.map((part, index) => (
      <Fragment key={index}>
        {index > 0 && ' · '}
        {typeof part === 'string' ? (
          part
        ) : 'unit' in part ? (
          <AttentionCount {...part} />
        ) : (
          <Translation span {...part} />
        )}
      </Fragment>
    ))}
  </>
)

AttentionStatusesMeta.displayName = 'AttentionStatusesMeta'
